import { TwoFactorConfirmStandard } from "@/components/Portal/UserAccount/Security/Change/TwoFactorConfirmStandard";

export const TwoFactorConfirmStandardView = () => <TwoFactorConfirmStandard />;
